import React, {Component} from 'react';
import './styles.scss';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import addFeideTwoSchool from 'api/addFeideTwoSchool';

class AddSchool extends Component {
	constructor(props) {
		super(props);
		this.state = {
			school: '',
			uuid: 'NO',
			showAlert: false,
		};
	}

	handleInputChange = (e) => {
		const {name, value} = e.target;

		if (name === 'uuid') {
			if (!value.startsWith('NO')) {
				this.setState({uuid: 'NO'});
			} else {
				this.setState({uuid: value});
			}
		} else {
			this.setState({
				[name]: value,
			});
		}
	};

	handleSubmit = (e) => {
		e.preventDefault();
		const {school, uuid} = this.state;

		const updatedUuid = uuid.startsWith('NO') ? uuid : `NO${uuid}`;
		addFeideTwoSchool(school, updatedUuid).then((res) => {
			if (!res) {
				this.setState({
					showAlert: true,
					error: true,
					success: false,
					message: strings.opsSomethingWentWrong,
				});
				setTimeout(() => {
					this.setState({
						showAlert: false,
					});
				}, 3000);
			} else {
				this.setState({
					showAlert: true,
					error: false,
					success: true,
					message: strings.schooldAdded,
					school: '',
					uuid: 'NO',
				});
				this.props.refreshSchools();
				setTimeout(() => {
					this.setState({
						showAlert: false,
					});
				}, 3000);
			}
		});
	};

	render() {
		const {school, uuid, showAlert, success, message} = this.state;

		return (
			<div className="form-container">
				<h2>{strings.addSchool}</h2>
				<form onSubmit={this.handleSubmit}>
					<input
						type="text"
						name="school"
						placeholder={strings.schoolName}
						value={school}
						onChange={this.handleInputChange}
					/>
					<input
						type="text"
						name="uuid"
						placeholder={strings.municipalityNumber}
						value={uuid}
						onChange={this.handleInputChange}
					/>
					<button disabled={!school || !uuid} type="submit">
						{strings.confirm}
					</button>
				</form>
				{showAlert && (
					<AlertBox
						type={success ? 'success' : 'error'}
						message={message}
					/>
				)}
			</div>
		);
	}
}

export default AddSchool;
